<template>
  <overflow-image-slide v-bind:image="content.image" v-bind:video="content.video" :videoFile="content.videoFile" v-bind:align="content.align" v-bind:active="active">

    <h2 v-html="title"></h2>
    
    <p v-for="paragraph in markedParagraphs" v-bind:key="paragraph.index" v-html="paragraph"></p>

  </overflow-image-slide>
</template>

<script>
  import overflow_image_slide from '../../components/organisms/overflow_image_slide'
  import marked from 'marked'
  import 'nodelist-foreach-polyfill'; // ie11

  import {is_active} from '../../utils/is_active'
  
  export default {
    props: ['title', 'content', 'active'],
    components: {
      'overflow-image-slide': overflow_image_slide
    },
    computed: {
      markedParagraphs () {
        if(this.content.paragraphs) {
          return this.content.paragraphs.map((paragraph) => {
            return marked(paragraph)
          })
        }
      }
    },
    watch: {
      active () {
        is_active(this, false)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// overflow_page.vue?051d7d44